import React from 'react'
import ProtectedRoute from './ProtectedRoute'

const EndUserProtectedRoute = props => {
  return (
    <ProtectedRoute {...props} sessionType='endUser' />
  )
}
export default EndUserProtectedRoute
